//^ Above is Stepper Implementation
import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {
    Alert,
    Button,
    Checkbox,
    Col,
    Form,
    Input,
    InputNumber,
    message,
    Radio,
    Row,
    Select,
    Spin,
    Typography
} from 'antd';
import {withRouter} from 'react-router';
import {EditOutlined, FileAddOutlined} from '@ant-design/icons';
import {colorArray} from '../../component/income/OrderTable';
import {URL_INCOME_ORDER} from '../../const';
import {getArtworkAdmin} from "../../api/artworks";
import axios from "../../config/axios";
import HttpError from "../../component/base/HttpError";
import {getArtistSaleReport, patchArtistSaleReports, postArtistSaleReports} from "../../api/artistSaleReports";

const {Title} = Typography
const {TextArea} = Input

const d = new Date()
const date = d.toLocaleDateString('en-CA');

const mapStateToProps = function (state) {
    return {
        artistId: state.user.info.artistId,
    }
}
export default withRouter(connect(mapStateToProps)(NewOrders));

function NewOrders(props) {
    const [builtOrder, setBuiltOrder] = useState({});
    const [skuList, setSkuList] = useState([])
    const [skuPrice, setSKUPrice] = useState([])
    const [dataLoading, setDataLoading] = useState(false)
    const [skuLoading, setSKULoading] = useState(false)
    const [actionLoading, setActionLoading] = useState(false)
    const onCancelButtonClick = () => {
        if (props.history) props.history.push({pathname: URL_INCOME_ORDER})
    }
    const cancelToken = axios.CancelToken.source()
    const ref = useRef(null)

    const getOrderId = () => {
        let id = props.match.params.id
        if (!id) {
            const locationArry = props.location.pathname.split('/')
            if (locationArry.length > 0) {
                if (locationArry[locationArry.length - 1]) {
                    id = parseInt(locationArry[locationArry.length - 1])
                } else {
                    id = parseInt(locationArry[locationArry.length - 2])
                }
            }
        }
        return id
    }

    useEffect(() => {
        if (props.artistId && props.isNew) {
            setSKULoading(true)
            getArtworkAdmin(1, 10000, null, null, props.artistId, {}, cancelToken).then(r => {
                setSkuList(r.data.results?.map((item) => {
                    return {
                        label: item.id + " " + item.name,
                        value: item.id
                    }
                }))
                setSKUPrice(r.data.results?.map((item) => {
                    return {
                        id: item.id,
                        price: item.price_type_str
                    }
                }))
            }).catch((error) => {
                HttpError(error)
            }).finally(() => {
                setSKULoading(false)
            })
        }
        return () => {
            if (skuLoading)
                cancelToken.cancel('cancel')
        }
    }, [props.artistId])

    useEffect(() => {
        if (!props.isNew && ref?.current) {
            setDataLoading(true)
            getArtistSaleReport(getOrderId())
                .then((response) => {
                    setDataLoading(false)
                    const order = response.data
                    ref.current.setFieldsValue(order)
                    setBuiltOrder(order)
                })
                .catch((error) => {
                    HttpError(error)
                }).finally(() => {
                setDataLoading(false)
            })
        }
        return () => {
            if (dataLoading)
                cancelToken.cancel('cancel')
        }
    }, [ref?.current])

    //The onChange method below is a pretty yucky way to handle the altercation of a new order; could likely incorporate formRef to handle this more nicely
    const onChange = e => {
        switch (e.target.name) {
            case 'sku_type':
                if (!builtOrder.sku_type || builtOrder.sku_type !== e.target.value)
                    setBuiltOrder({...builtOrder, sku_type: e.target.value})

                if (e.target.value === 'Original') {
                    const values = ref?.current?.getFieldsValue(['sku_id'])
                    if (values && values.sku_id) {
                        const find = skuPrice.filter((item) => (item.id === values.sku_id))
                        if (find && find.length > 0) {
                            ref?.current?.setFieldsValue({
                                'sku_price': find[0].price ?? '',
                                'sku_quantity': 1
                            })
                        }
                    }
                }
                break;
            case 'payment_status':
                setBuiltOrder({...builtOrder, payment_status: e.target.value})
            default:
                break;
        }
    }

    const onFinish = (value) => {
        if (!props.artistId) return
        const orderParam = {
            date: date,
            ...value,
            sku_price: Number(value.sku_price),
            ups_tracking_num: value.ups_tracking_num ? value.ups_tracking_num.toString() : "",
            checkout_reference: '',
            artist: props.artistId
        }
        if (props.isNew) {
            orderParam.order_status = 'buyer-paid'
        }
        setActionLoading(true)
        if (props.isNew) {
            postArtistSaleReports(orderParam)
                .then(async (response) => {
                    message.success('Saved successfully').then((r) => {
                    })
                    if (props.history) props.history.push({pathname: URL_INCOME_ORDER})
                })
                .catch((error) => {
                    HttpError(error);
                }).finally(() => {
                setActionLoading(false)
            })
        } else {
            patchArtistSaleReports(getOrderId(), orderParam)
                .then(async (response) => {
                    message.success('Saved successfully').then((r) => {
                    })
                    if (props.history) props.history.push({pathname: URL_INCOME_ORDER})
                })
                .catch((error) => {
                    HttpError(error);
                }).finally(() => {
                setActionLoading(false)
            })
        }
    }

    const getTitle = () => {
        if (props.isNew) {
            return (
                <Title style={{marginBottom: 16}}>
                    <FileAddOutlined style={{marginRight: 8}}/>
                    New Order
                </Title>
            )
        } else {
            return (
                <Title style={{marginBottom: 16}}>
                    <EditOutlined style={{marginRight: 8}}/>
                    Edit Order #{getOrderId()}
                </Title>
            )
        }
    }
    return (
        <Spin size='large' spinning={dataLoading}>
            <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                <Col>
                    {getTitle()}
                </Col>
            </Row>
            {!props.artistId && (
                <Alert type={'error'} message={'No artist was selected'}/>
            )}
            <Form layout="vertical" onFinish={onFinish} ref={ref}
                  style={{padding: 12, marginTop: 12, marginLeft: 'auto', marginRight: 'auto', maxWidth: 840}}>
                <Row gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col xs={24} lg={24}>
                        <Spin size='small' spinning={skuLoading}>
                            <Form.Item label="SKU ID" name="sku_id" onChange={onChange}
                                       rules={[{required: true, message: 'Please input the sku id!'}]}>
                                <Select
                                    defaultValue=""
                                    showSearch={true}
                                    style={{
                                        width: '100%',
                                    }}
                                    options={skuList}
                                    onChange={(item) => {
                                        try {
                                            const nameItem = skuList.filter((sku) => {
                                                return sku.value === item
                                            })
                                            const suffix = nameItem[0].value + " "
                                            const name = nameItem[0].label.replace(suffix, "")
                                            ref?.current?.setFieldsValue({
                                                'sku_name': name
                                            })
                                        } catch (e) {
                                        }
                                    }}
                                />

                            </Form.Item>
                        </Spin>
                        <Form.Item label="SKU Name" name="sku_name" onChange={onChange}>
                            <Input name="sku_name" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Buyer Payment (admin)" name="payment_status" onChange={onChange}
                                   rules={[{required: true, message: 'Please input the payment type!'}]}>
                            <Radio.Group name="payment_status">
                                <Radio.Button value="paid" style={{
                                    background: (builtOrder.payment_status === "paid" ? colorArray.payment["buyer-paid"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Buyer Paid</Radio.Button>
                                <Radio.Button value="unpaid" style={{
                                    background: (builtOrder.payment_status === "unpaid" ? colorArray.payment["buyer-unpaid"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Buyer Unpaid</Radio.Button>
                                <Radio.Button value="partially-paid" style={{
                                    background: (builtOrder.payment_status === "partially-paid" ? colorArray.payment["partially-paid"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Partially Paid</Radio.Button>
                                <Radio.Button value="refunded" style={{
                                    background: (builtOrder.payment_status === "refunded" ? colorArray.payment["refunded"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Refunded</Radio.Button>
                                <Radio.Button value="none" style={{
                                    background: (builtOrder.payment_status === "none" ? colorArray.payment["none"] : '#d9d9d9'),
                                    color: 'white'
                                }}>None</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="Type" name="sku_type" onChange={onChange}
                                   rules={[{required: true, message: 'Please input the artwork type!'}]}>
                            <Radio.Group name="sku_type">
                                <Radio.Button value="Original" style={{
                                    background: (builtOrder.sku_type === "Original" ? colorArray.type["Original"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Original</Radio.Button>
                                <Radio.Button value="Print" style={{
                                    background: (builtOrder.sku_type === "Print" ? colorArray.type["Print"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Print</Radio.Button>
                                <Radio.Button value="Commission" style={{
                                    background: (builtOrder.sku_type === "Commission" ? colorArray.type["Commission"] : '#d9d9d9'),
                                    color: 'white'
                                }}>Commission</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="Price" name="sku_price" onChange={onChange}
                                   rules={[{required: true, message: 'Please input the order price!'}]}>
                            <Input name="sku_price" prefix="$" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Quantity" name="sku_quantity" onChange={onChange}
                                   rules={[{required: true, message: 'Please input the order quantity!'}]}>
                            <InputNumber name="sku_quantity" prefix="x" style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col xs={24} lg={24}>
                        <Form.Item label="Buyer Name" name="buyer_name" onChange={onChange}
                                   rules={[{required: false, message: 'Please input the buyer name!'}]}>
                            <Input name="buyer_name" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Buyer E-Mail" name="buyer_email" onChange={onChange}
                                   rules={[{required: false, message: 'Please input the buyer e-mail!'}]}>
                            <Input name="buyer_email" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Buyer Address" name="buyer_address" onChange={onChange}
                                   rules={[{required: false, message: 'Please input the buyer address!'}]}>
                            <Input name="buyer_address" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Buyer Contacts" name="buyer_contacts" onChange={onChange}>
                            <Input name="buyer_contacts" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Buyer Company" name="buyer_company" onChange={onChange}>
                            <Input name="buyer_company" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="UPS Tracking Number" name="ups_tracking_num" onChange={onChange}
                                   rules={[{required: false, message: 'Please input the UPS Tracking Number!'}]}>
                            <Input name="ups_tracking_num" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Coupon Code" name="order_coupon_code" onChange={onChange}>
                            <Input name="order_coupon_code" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Notes" name="notes_str" onChange={onChange}>
                            <TextArea rows={4} name="notes_str" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Sales Channel" name="sales_channel" onChange={onChange}>
                            <Input name="sales_channel" style={{width: '100%'}}/>
                        </Form.Item>
                        <Form.Item label="Pick Up in Gallery?" name="is_pick_up" onChange={onChange}>
                            <Checkbox defaultChecked={false} name="is_pickup" style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{display: 'flex', width: '100%', flexDirection: 'row'}}>
                    <Button danger onClick={onCancelButtonClick} style={{marginRight: 'auto', marginLeft: 12}}>
                        Cancel Changes
                    </Button>
                    <Button type='primary' htmlType='submit' style={{marginLeft: 'auto', marginRight: 12}}
                            loading={actionLoading}
                            disabled={actionLoading}
                    >
                        Save Changes
                    </Button>
                </Row>
            </Form>
        </Spin>
    )
}